import { render, staticRenderFns } from "./TariffsTable.vue?vue&type=template&id=123d8102&scoped=true"
import script from "./TariffsTable.vue?vue&type=script&lang=js"
export * from "./TariffsTable.vue?vue&type=script&lang=js"
import style0 from "./TariffsTable.vue?vue&type=style&index=0&id=123d8102&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123d8102",
  null
  
)

export default component.exports